import { gql } from '@apollo/client';

export interface Tag {
  name: string;
  uuid: string;
}

export interface GetRootTagsByKeyResult {
  tags: Tag[];
}

export const GET_ROOT_TAGS_BY_KEY = gql`
  query GetRootTags($key: String!) {
    tags(where: { root_tags: { key: { equals: $key } } }) {
      name
      uuid
    }
  }
`;
